import { render } from "./SurveyPassingModal.vue?vue&type=template&id=05ecbc96&scoped=true"
import script from "./SurveyPassingModal.vue?vue&type=script&lang=js"
export * from "./SurveyPassingModal.vue?vue&type=script&lang=js"

import "./SurveyPassingModal.vue?vue&type=style&index=0&id=05ecbc96&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ecbc96"]])

export default __exports__